import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import FragmentFullContent from "./FragmentFullContent";

interface FragmentCardContentProps {
  image: string;
  title: string;
  description: React.ReactNode;
}

const FragmentCardContent = ({ image, title, description }: FragmentCardContentProps) => {
  return <>
    <FragmentFullContent>
        <Card sx={{ display: "flex", m: 1 }} elevation={3}>
        <CardMedia component="img" sx={{ width: { xs: 80, sm: 160 } }} image={image} />
        <CardContent sx={{ flex: 1 }}>
            <Typography component="h2" variant="h6">
                {title}
            </Typography>
            <Typography variant="subtitle2">
                {description}
            </Typography>
        </CardContent>
        </Card>
    </FragmentFullContent>
  </>;
};

export default FragmentCardContent;